// extracted by mini-css-extract-plugin
module.exports = {"container":"dashboard-layout_container__3NNrT","content-container":"dashboard-layout_content-container__3Vfh2"};